import { Component, OnInit } from '@angular/core';


import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { NotificationsService } from './notifications.service';
import { Router, RouterEvent, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, Event } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
})
export class AppComponent implements OnInit {
  loading: boolean = false;

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private notificationsService: NotificationsService,
    private router: Router,
  ) {

    router.events.subscribe((event: Event) => {
      if (event instanceof RouterEvent) {
        this.navigationInterceptor(event);
      }
    });

    this.initializeApp();

  }

  ngOnInit() {
    // await this.notificationsService.requestPermission();
    // await this.notificationsService.listenForMessages();
    // await this.notificationsService.refreshToken();
  }

   // Shows and hides the loading spinner during RouterEvent changes
   navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.loading = true
    }
    if (event instanceof NavigationEnd) {
      this.loading = false
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.loading = false
    }
    if (event instanceof NavigationError) {
      this.loading = false
    }
  }

  // async ngOnInit() {
    // firebase.initializeApp(environment.firebase);
    // this.initializeApp();
    // await this.notificationsService.init();
  // }


  initializeApp() {
    this.platform.ready().then(async () => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      const authToken = localStorage.getItem('token') ? localStorage.getItem('token') : 0;
      if (authToken === 0) {
        this.router.navigate(['/login']);
      }
    });
  }
}
